module.exports = __webpack_public_path__ + "static/img/flogo.8767d086.png";